import * as React from "react";
const SvgFiRrListCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-list-check_svg__a)">
      <path
        fill="#062147"
        d="M4 6a2.98 2.98 0 0 1-2.122-.88L.334 3.748a1 1 0 0 1 1.332-1.494L3.25 3.667a1 1 0 0 0 1.456.04L8.31.276a1 1 0 0 1 1.378 1.448l-3.59 3.414A2.96 2.96 0 0 1 4 6m20-2a1 1 0 0 0-1-1H13a1 1 0 1 0 0 2h10a1 1 0 0 0 1-1M6.1 13.138l3.589-3.414A1 1 0 1 0 8.31 8.276l-3.6 3.43a1.023 1.023 0 0 1-1.414 0l-1.59-1.584a1 1 0 0 0-1.414 1.414l1.585 1.585a3 3 0 0 0 4.226.017zM24 12a1 1 0 0 0-1-1H13a1 1 0 1 0 0 2h10a1 1 0 0 0 1-1M6.1 21.138l3.585-3.414a1 1 0 1 0-1.378-1.448l-3.6 3.43a1 1 0 0 1-1.456-.04l-1.585-1.413a1 1 0 1 0-1.332 1.494l1.544 1.374a3 3 0 0 0 4.226.017zM24 20a1 1 0 0 0-1-1H13a1 1 0 1 0 0 2h10a1 1 0 0 0 1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-list-check_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrListCheck;
